'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.DIContext = exports.getDIContext = exports.DisableSsrContext = void 0;
var tslib_1 = require('tslib');
var react_1 = require('react');
var services_1 = require('./services');
var EMPTY_ARR = [];
exports.DisableSsrContext = (0, react_1.createContext)(false);
var getDIContext = function () {
    var container = {};
    var createServiceActions = (0, services_1.serviceActionsFactory)();
    function registerDependency(key, dependency) {
        if (container[key]) {
            return;
        }
        container[key] = dependency;
    }
    function getDependency(key) {
        var record = container[key];
        if (!record) {
            throw new Error('Register dependency first by key '.concat(key));
        }
        return record;
    }
    var context = {
        registerDependency: registerDependency,
        getDependency: getDependency,
        registerService: function (service) {
            registerDependency(service.toString(), service);
        },
        getService: function (Ctr) {
            return getDependency(Ctr.prototype.toString());
        },
        createService: function (Ctr) {
            var key = Ctr.prototype.toString();
            if (container[key]) {
                return container[key];
            }
            var metaTarget = Ctr;
            var meta;
            while (metaTarget) {
                meta = metaTarget.__injects;
                if (meta) break;
                metaTarget = Object.getPrototypeOf(metaTarget);
            }
            function depMap(key) {
                return typeof key === 'function' ? context.getService(key) : getDependency(key);
            }
            return new (Ctr.bind.apply(
                Ctr,
                (0, tslib_1.__spreadArray)([void 0], (0, tslib_1.__read)((meta || EMPTY_ARR).map(depMap)), false)
            ))();
        },
        createServiceActions: createServiceActions,
    };
    return context;
};
exports.getDIContext = getDIContext;
exports.DIContext = (0, react_1.createContext)(null);
